var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252,
    height: 200,
    viewBox: "0 0 252 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_3827",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 10,
    width: 179,
    height: 179
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.431 162.431C223.12 127.742 223.12 71.4994 188.431 36.8103C153.742 2.12113 97.4994 2.12111 62.8103 36.8103C28.1211 71.4994 28.1211 127.742 62.8103 162.431C97.4994 197.12 153.742 197.12 188.431 162.431Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_3827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.37 178.029C185.37 198.171 65.8721 198.171 65.8721 178.029C65.8721 157.887 113.027 150.055 125.621 150.055C138.216 150.055 185.37 157.888 185.37 178.029Z",
    fill: "#F25B08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.621 160.413C119.774 160.413 115.035 155.674 115.035 149.827V125.71H136.207V149.827C136.207 155.674 131.468 160.413 125.621 160.413Z",
    fill: "#F7BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.203 143.632V134.4H115.033V143.632C118.303 144.962 121.883 145.692 125.623 145.692C129.363 145.692 132.933 144.962 136.203 143.632Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.621 139.035C110.039 139.035 97.406 126.403 97.406 110.821V83.1835C97.406 67.6015 110.038 54.9695 125.62 54.9695C141.202 54.9695 153.834 67.6015 153.834 83.1835V110.82C153.836 126.403 141.204 139.035 125.621 139.035Z",
    fill: "#F7BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.061 109.291C103.041 105.143 100.472 100.987 96.3245 100.007C92.1767 99.0279 88.0203 101.596 87.0409 105.744C86.0615 109.892 88.63 114.048 92.7778 115.028C96.9255 116.007 101.082 113.439 102.061 109.291Z",
    fill: "#F7BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.05 107.995C88.774 107.995 88.55 107.771 88.55 107.495C88.55 104.18 91.2471 101.484 94.5611 101.484C94.8371 101.484 95.0611 101.708 95.0611 101.984C95.0611 102.26 94.8371 102.484 94.5611 102.484C91.7981 102.484 89.55 104.732 89.55 107.495C89.55 107.771 89.327 107.995 89.05 107.995Z",
    fill: "#011F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46 114.978C162.608 113.999 165.176 109.842 164.197 105.695C163.217 101.547 159.061 98.9784 154.913 99.9578C150.765 100.937 148.197 105.094 149.176 109.241C150.156 113.389 154.312 115.958 158.46 114.978Z",
    fill: "#F7BD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.192 107.995C161.916 107.995 161.692 107.771 161.692 107.495C161.692 104.732 159.444 102.484 156.68 102.484C156.404 102.484 156.18 102.26 156.18 101.984C156.18 101.708 156.404 101.484 156.68 101.484C159.995 101.484 162.692 104.181 162.692 107.495C162.692 107.771 162.468 107.995 162.192 107.995Z",
    fill: "#011F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.049 61.0425C156.511 59.0815 152.043 60.0635 148.357 61.1905C146.056 42.5665 106.64 56.6205 99.7361 66.5255C95.6251 70.7945 93.1131 79.4565 95.4721 85.2125C95.5751 85.4215 95.6921 85.6035 95.8221 85.7615L97.4071 100.324C100.653 100.324 102.507 90.6975 103.4 84.0445C109.581 79.7895 116.897 71.6265 116.897 71.6265C116.537 79.7215 134.127 85.7455 147.728 83.1615C148.572 89.8065 150.443 100.324 153.836 100.324L156.043 80.0405C159.32 77.9625 161.763 74.9405 162.735 70.7825C164.025 67.3635 163.174 62.9375 160.049 61.0425Z",
    fill: "#011F26"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6710b03cd65defb57775210712c6c547.svg";
export { ForwardRef as ReactComponent };